<template>
  <div class="coreProduct">
    <img src="/status/hexincanping.jpg">
    <div class="middle_box_list">
      <div class="top_list" >
        <div :class="tarIndex == index ?'tar_info blue':'tar_info'" v-for="(item,index) in tarList" :key="index" @click="select(index)">
          <div class="item">{{item}}</div>
          <div v-if="index != 7" class="border_info"></div>
        </div>
      </div>
      <div class="core_list">
        <div class="core_info" v-for="(item,index) in coreProductList[tarIndex]" :key="index" @click="toCheck(item)">
          <div class="image">
            <el-image class="image_img" :src="item.img" fit = 'contain' />
            <el-image class="imgInfo" v-if="item.imgInfo" :src="item.imgInfo" fit = 'contain' />
          </div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import {coreProductList} from '@/views/mock'
import tail_menu from "@/components/tail_menu";
export default {
  name: "coreProduct",
  components:{
    tail_menu,
  },

  data(){
    return{
      coreProductList:coreProductList,
      tarIndex:0,
      tarList:[
        '智慧医疗',
        '智慧病房',
        '智慧门诊',
        '互联网医疗',
        '医疗器械',
          '智慧心理',
          '智慧中医',
          '智能化评估训练系统'
      ]
    }
  },
  created(){
    this.tarIndex = this.$route.query.fid
  },
  methods:{
    select(index){
      this.tarIndex = index
    },
    toCheck(item) {
      this.$router.push({name: 'coreProductInfo', query: {id: item.id,fid:this.tarIndex}})
    }
  }
}
</script>

<style scoped lang="scss">
.coreProduct{
  img{
    width: 100%;
  }
  .middle_box_list{
    display: flex;
    align-items: center;
    flex-direction: column;
    .top_list{
      display: flex;
      justify-content: space-around;
      width: 1200px;
      padding: 14px 0;
      .tar_info{
        padding-bottom: 10px;
        justify-content: center;
        cursor: pointer;
        font-weight: bold;
        font-size: 17px;
        display: flex;
        .item{
          white-space: nowrap;
          margin-left: 50px;
          margin-right: 50px;
        }
        .border_info{
          background: rgb(216,216,216);
          width: 2px;
          height: 100%;
        }
      }
      .blue{

        border-bottom: 1px solid #4a7bac;
        color: #4a7bac;
      }
    }
    .core_list{
      display: flex;
      flex-wrap: wrap;
      width: 1400px;
      margin-left: 100px;
      margin-top: 20px;
      .core_info{
        cursor: pointer;
        background: white;
        padding: 10px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        margin-bottom: 30px;
        margin-left: 30px;
        border-radius: 8px;
        .image{
          position: relative;
          .image_img{
            width: 280px;
            height: 260px;
          }
          .imgInfo{
            position: absolute;
            left: 39px;
            top: 36px;
            width: 204px;
            height: 120px;
          }
        }
        .name{
          text-align: center;
          margin-top: 10px;
          font-size: 17px;
          margin-bottom: 10px;
          width: 280px;
        }
      }
    }
  }
}
</style>
